import { Component, Inject, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { APPCONFIG } from "./config";
import { LayoutService } from "./layout/layout.service";
import { HttpService } from "./shared/services/http.service";
import { SessionHandler } from "./shared/services/session-handler.service";
import { TranslateService } from "@ngx-translate/core";
import { OKTA_AUTH, OktaAuthStateService } from "@okta/okta-angular";

import "styles/font-awesome.scss";
import "styles/material2-theme.scss";
import "styles/bootstrap.scss";
import "styles/layout.scss";
import "styles/theme.scss";
import "styles/ui.scss";
import "styles/app.scss";

import { CommonService } from "./shared/services/common.service";
import OktaAuth from "@okta/okta-auth-js";

@Component({
  selector: "app-root",
  template: require('./app.component.html'),
  providers: [LayoutService, HttpService, SessionHandler],
})
export class AppComponent implements OnInit {
  AppConfig: any;
  initParam: any;
  flag = true;
  loading = true;

  constructor(
    private router: Router,
    public translate: TranslateService,
    public httpService: HttpService,
    private commonService: CommonService,
    private oktaAuthStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {
    localStorage.removeItem("selectedValue");
    translate.use("en");

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.flag = false;
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  async ngOnInit() {
    this.AppConfig = APPCONFIG;

    // ✅ Handle login callback first
    if (this.isLoginCallbackUrl()) {
      try {
        await this.oktaAuth.handleLoginRedirect();
        const targetRoute =
          localStorage.getItem("postLoginRedirect") || "/app/documents";
        localStorage.removeItem("postLoginRedirect");

        // Use full replace to clean URL
        window.location.replace(`${window.location.origin}/#${targetRoute}`);
      } catch (err) {
        console.error("Error handling Okta login redirect:", err);
        window.location.replace(`${window.location.origin}/#/extra/login`);
      }
      return; // stop here, don't run normal auth check
    }

    // ✅ Listen for actual auth state changes
    this.oktaAuthStateService.authState$.subscribe((state) => {
      if (state.isAuthenticated) {
        if (this.router.url === "/" || this.router.url === "") {
          this.router.navigateByUrl("/app/documents", { replaceUrl: true });
        }
      } else {
        this.router.navigateByUrl("/extra/login", { replaceUrl: true });
      }
      this.loading = false;
    });
  }

  private isLoginCallbackUrl(): boolean {
    const href = window.location.href;
    return (
      href.includes("id_token") ||
      href.includes("access_token") ||
      href.includes("code")
    );
  }
}
